import { getLabayhPlusSubscriptionApi } from "@/common/api";
import { useQuery } from "@tanstack/react-query"

const useLabayhPlusSubscription = (enabled: boolean) => {
  const query = useQuery({
    enabled,
    queryKey: ["labayh-plus-subscription"],
    queryFn: getLabayhPlusSubscriptionApi,
    refetchOnWindowFocus: false,
  });

  return query
}

export default useLabayhPlusSubscription;